import http from './http-common';
import { AxiosResponse } from 'axios';

class WarrantyService {
  async createWarrantyRequest(): Promise<AxiosResponse> {
    return http.post('/warranty/request');
  }
}

const warrantyService = new WarrantyService();

export default warrantyService;
